import API from "../API";

export default class Language extends API {
  constructor() {
    super('language')
  }
 
}
